<template>
<div class="chapter">
<div class="inner_page">
<p class="ORIM-Dedication--Front-Matter-">For Christina</p>
<p class="ORIM-Dedication--Front-Matter-"><i>Aloha pau ole</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?1532b950